import type { ListFilterFieldDef, ListFilterValues } from '../../types'

export function readListFiltersFromParams(
  params: URLSearchParams,
  fields: readonly ListFilterFieldDef[]
): ListFilterValues {
  return Object.fromEntries(
    fields.map((field) => {
      const value = params.get(field.key) ?? ''
      const isAllowed =
        field.kind === 'text' ||
        field.searchMode === 'contains' ||
        field.options.some((option) => option.value === value)
      return [field.key, isAllowed ? value : '']
    })
  )
}
